import React, {Component, Fragment} from 'react';
import {Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import CreateNotificationForm from "../../../../containers/CreateNotificationForm";
import Breadcrumb from '../../../../containers/navs/Breadcrumb';

class Update extends Component {
  render() {
    const {match, location} = this.props;
    const {state} = location;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <CreateNotificationForm category="DECLARATION" notification={state}/>
      </Fragment>
    );
  }
}

export default Update;
